
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Table,
} from "reactstrap";
import { fetchStates } from "slices/stateSlice";
import { stateSelector } from "slices/stateSlice";

import Api from "services/api"
import AddState from "components/state/AddState";
import { removeState } from "slices/stateSlice";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { SortButtons } from "components/common/SortButtons";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/stateSlice";
import { removeMultipleStates } from "slices/stateSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";

const apiService = new Api();

function StateList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions();
  const { state: states, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(stateSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });



  React.useEffect(() => {
    dispatch(fetchStates())
  }, [])

  const handleAddStatePopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchStates())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleStates({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(states?.map((state) => state.id.toString()))


  }

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchStates(page));
  }, [])

  const handleClose = () => {
    refAddutton.current.click(); setAddForm({ show: false })
  };

  const handleSelect = (value) => {
    setSelectedValue(value)

  }


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {


    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchStates(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th className="col-2">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete States') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th className="col-4">


          <TableHeaderItem
            title="State Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-4">


          <TableHeaderItem
            title="Timezone"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>


        <th className="col-4">
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Status States') &&
          <th >Status</th>
        }
        {checkPermission('Edit States') &&
          <th >Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      states?.map((state, index) => (
        <StateItem state={state} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddStatePopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      ))
    )
  }, [states, selectedItems]);

  //#endregion


  return (
    <ListLayout
      heading="State"
      time={true}
      title=""
      buttonTitle="Add State"
      renderTableHeader={renderTableHeader}
      addButtonDisabled={!checkPermission('Create States')}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchStates}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => <AddState item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission('Status States')} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddStatePopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder="Search State ..."
      noOfItems={total}
    >

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}


const StateItem = ({
  state, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(state?.status == "active" ? 1 : 0 || 0);

  React.useEffect(() => {
    setStatus(state?.status == "active" ? 1 : 0 || 0)

  }, [state])
  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }
  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete States') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={state.id} checked={selectedItems.includes(state.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {state.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {  state?.timezone && state?.timezone?.display_name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {convertTimeToUTC(state.created_at)}
      </td>
      {checkPermission('Status States') &&
        <td style={getBackgroundStyle(status)}>
          <CustomSwitch handleChange={(status) => handleStatusChange(state?.id, status)} checked={status == 1 ? true : false} />
        </td>
      }
      {checkPermission('Edit States') &&
        <td style={getBackgroundStyle(status)}>
          <button className="table_edit" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleAddPopUp({ ...state, status })}>Edit</button>
        </td>
      }
    </tr>
  )
}


export default StateList;
